var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            { slot: "left" },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "show-side-bar": false,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false,
                  "min-height": "100%",
                  "grid-style": "min-width: 160px;width:100%;height:100%;"
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c("cargo-button-group-slider", [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "look",
                                expression: "action==='look'"
                              }
                            ]
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "1" },
                                on: { click: _vm.goBack }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: !(
                                    _vm.job &&
                                    Number(_vm.job.jobState) === 0 &&
                                    !_vm.JobUtils.isBlockJob(_vm.job)
                                  ),
                                  type: "success",
                                  no: "2"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler("edit")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      (_vm.$checkPermission([
                                        "button_SEDocuments_reEdit"
                                      ]) ||
                                        _vm.$store.getters.isAdmin) &&
                                      _vm.job && Number(_vm.job.jobState) > 0,
                                    expression:
                                      "($checkPermission(['button_SEDocuments_reEdit']) || $store.getters.isAdmin) && (job && Number(job.jobState) > 0)"
                                  }
                                ],
                                attrs: { type: "success", no: "3" },
                                on: {
                                  click: function($event) {
                                    return _vm.editHandler("editAgain")
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.editAgain")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  disabled: _vm.enablePrint,
                                  type: "success",
                                  no: "4"
                                },
                                on: { click: _vm.onPrint }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.action === "edit",
                                expression: "action==='edit'"
                              }
                            ],
                            staticStyle: {
                              "border-left": "none",
                              "padding-left": "0"
                            }
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "5" },
                                on: { click: _vm.save }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "success", no: "6" },
                                on: {
                                  click: function($event) {
                                    _vm.cancelEdit(function() {
                                      _vm.againShow("look")
                                    })
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "7" },
                                on: { click: _vm.saveDefaultVal }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("SeaExport.SaveTheDefaultValues")
                                  )
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.action === "look" || _vm.action === "edit",
                              expression: "action==='look'||action==='edit'"
                            }
                          ],
                          staticStyle: {
                            display: "flex",
                            "white-space": "nowrap"
                          }
                        },
                        [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content: _vm.$t("SeaExport.Tip2"),
                                placement: "bottom-start"
                              }
                            },
                            [
                              _c("img", {
                                staticStyle: {
                                  width: "20px",
                                  "margin-right": "5px"
                                },
                                attrs: { src: _vm.locationImg, no: "8" },
                                on: { click: _vm.toQueryDataPushLog }
                              })
                            ]
                          ),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    cursor: "pointer"
                                  },
                                  attrs: { no: "9" },
                                  on: {
                                    mousemove: _vm.resetSopTooltip,
                                    dblclick: function($event) {
                                      return _vm.onBtnListDoubleClicked()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "14px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobState))]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      "font-size": "12px",
                                      padding: "5px 9px",
                                      color: "unset"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "red",
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "5px 0"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.commonInfo.jobLock))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !(_vm.isLclMaster && _vm.isNew) &&
                      (_vm.masterFlag || _vm.paramsOfTab.signMBL) &&
                      _vm.privilege.seBooking.mbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabMBL",
                                label: "MB/L"
                              }
                            },
                            [
                              _c("tab-mbl", {
                                ref: "tabMBL",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                },
                                on: { resetTab: _vm.resetTab }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.mbl2 &&
                      _vm.paramsOfTab.typeMBL !== 0 &&
                        _vm.paramsOfTab.typeMBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabMBL2",
                                label:
                                  "MB/L" +
                                  (_vm.paramsOfTab.typeMBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeMBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _c("tab-mbl2", {
                                ref: "tabMBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.paramsOfTab.signHBL &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.hbl
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 3,
                              attrs: {
                                lazy: true,
                                name: "tabHBL",
                                label: "HB/L"
                              }
                            },
                            [
                              _c("tab-hbl", {
                                ref: "tabHBL",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                },
                                on: {
                                  resetTab: _vm.resetTab,
                                  syncData: _vm.syncData
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.paramsOfTab.mblOnly &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.hbl2 &&
                      _vm.paramsOfTab.typeHBL !== 0 &&
                        _vm.paramsOfTab.typeHBL !== 1
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabHBL2",
                                label:
                                  "HB/L" +
                                  (_vm.paramsOfTab.typeHBL === 2
                                    ? _vm.$t("CargoMsg.Cargo_SplitBL")
                                    : "") +
                                  (_vm.paramsOfTab.typeHBL === 3
                                    ? _vm.$t("SeaExport.MergeAndSingle")
                                    : "")
                              }
                            },
                            [
                              _c("tab-hbl2", {
                                ref: "tabHBL2",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.isNew &&
                      _vm.paramsOfTab.ams &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.ams
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabAMS",
                                label: "AMS/ENS"
                              }
                            },
                            [
                              _c("tab-ams", {
                                ref: "tabAMS",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      !_vm.masterFlag &&
                      _vm.privilege.seBooking.containersLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-container", {
                                ref: "tabContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !(_vm.isLclMaster && _vm.isNew) &&
                      _vm.masterFlag &&
                      !_vm.isNew &&
                      _vm.privilege.seBooking.lclManagerLayer
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabLclContainer",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("tab-lcl-container", {
                                ref: "tabLclContainer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("estimate-validation-dialog", {
        ref: "estimateValidationDialog",
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.dataPushDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "app-main-inner",
              attrs: {
                visible: _vm.dataPushDialog.visible,
                title: _vm.$t("SeaExport.DataPushChangeLog"),
                width: "580px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.dataPushDialog, "visible", $event)
                },
                close: function($event) {
                  _vm.dataPushDialog.visible = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    padding: "0",
                    display: "flex",
                    "flex-direction": "column"
                  },
                  style: { width: "100%", height: "400px", overflow: "auto" }
                },
                _vm._l(_vm.dataPushDialog.titles, function(title, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c("div", { staticStyle: { background: "#EBECF5" } }, [
                        _c("b", [_vm._v(_vm._s(title))])
                      ]),
                      _vm._l(_vm.dataPushDialog.dataMap.get(title), function(
                        item,
                        index
                      ) {
                        return _c("div", { key: index }, [
                          _c("div", [_vm._v(_vm._s(item))])
                        ])
                      })
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }